import { render, staticRenderFns } from "./QuestionType4.vue?vue&type=template&id=c122c9c2&scoped=true"
import script from "./QuestionType4.vue?vue&type=script&lang=js"
export * from "./QuestionType4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c122c9c2",
  null
  
)

export default component.exports